import React from 'react'
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from "swiper/react";
import { Container, Row, Col,} from "react-bootstrap"
import './Home.scss'
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import BackgroundImage from './rectangle.png';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Navigation, Pagination, Mousewheel, Keyboard } from "swiper";
import { FaSistrix, FaSlidersH, FaGreaterThan } from 'react-icons/fa';


const LiquidInner = styled.div`
background:white;
`
const SocialCommunities = styled.div`
    background-color:white;
    color:black;
    position: absolute;
    right:250px;
    bottom: 100px;
    font-size: 35px;
    text-align: center;
    font-size:12px;
    padding: 7px 10px;
    border-radius: 3px;
    font-family: 'Noto Sans';
    cursor: pointer;
    &:hover{background-color:black;color:white}

@media (max-width: 575px) {
  right:100px
};

@media (min-width: 768px) and (max-width: 991px) {
  right:100px;
  bottom:125px;
}
@media (min-width: 992px) and (max-width: 1199px) {
  right:165px
}
`;

const SearchComponentContainer = styled.div`
padding:8% 12%;
@media (max-width: 575px) {
  padding:4% 8% 12%;
}
`

const SearchForm = styled.form`
padding-top:7%;
position: relative;
@media (max-width: 575px) {
  padding-top:4%;
}
@media (min-width: 768px) and (max-width: 991px) {
  padding-top:10%;

}
`

const LearningLibrary = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
padding-left: 40px;
background-color: black;
z-index: -1;
padding-top: 10px;
@media (max-width: 575px) {}
padding-left: 20px;

`
const SearchIcon = styled.i`
position: absolute;
left:8px;
padding: 1.5% 0;

@media (max-width: 575px) {
  padding: 2.5% 0;

}
@media (min-width: 768px) and (max-width: 991px) {
  padding: 3.5% 0;
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) and (max-width: 1199px) {
  padding: 2.5% 0;

}
`
const SearchIcons = styled.i`
  position: absolute;
  padding: 1.8% 0;
  right: 28%;
  display:inline-flex;
  bottom: 2px;
  @media (max-width: 575px) {
  top:24px;
  padding: 0;
};

@media (min-width: 768px) and (max-width: 991px) {
  padding: 3% 0;
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) and (max-width: 1199px) {
  padding: 2.4% 0;

}
`

const LineBreak = styled.hr`
    display: flex;
    background: #000000;
    height: 15px;
    width: 1px;
    justify-content: center;
    align-items: center;
    margin: -2px 8px;
`
const CardContent = styled.div`
  padding:15px 15px 30px 15px;
  background-color: white;
  margin-bottom: 30px;
  border-radius: 0 0 3px 3px;
   @media (min-width: 568px) and (max-width: 767px) {
    padding:10px 10px 15px 10px;
  }
  /* @media (min-width: 992px) and (max-width: 1199px) {
    padding:10px 10px 15px 10px;
  }
  @media (min-width: 768px) and (max-width: 991px) {}
  padding:10px 10px 15px 10px;  */

`
const CardProgress = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
`

function SearchComponent() {
  return <>
    <Col md={6} className="backgroungWhite" >
      <LiquidInner className="LiquidCrystal-inner1">
        <Link to="/">BROWSE ALL LEARNING</Link>
        <SearchComponentContainer>
          <h1>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit
          </h1>
          <SearchForm>         
            <form class="form-inline md-form form-sm mt-0">
              <SearchIcon>
                 <FaSistrix />
              </SearchIcon>
              <input class="form-control form-control-sm ml-3 w-75" type="text" placeholder="What would you like to learn today" aria-label="Search"/>
              <SearchIcons>
                  <Link to="/" className='SearchIconsStyles'><FaSlidersH/> </Link>
                  <LineBreak/>
                  <Link to="/" className='SearchIconsStyles'> <FaGreaterThan/> </Link>
              </SearchIcons>
            </form>
          </SearchForm>
        </SearchComponentContainer>

      </LiquidInner>
    </Col></>
}

function Courses (){
  return<>
        <Col md={6} id="Coaching">
          <div className="LiquidCrystal-inner2" style={{ backgroundImage: `url(${BackgroundImage})` }}>
            <Link to="/">VIEW PROFILE</Link>
            <div className='liquidCrystal'>
              <img src={process.env.PUBLIC_URL + "images/liquid.png"} alt="Liquid Crystal" />
              <div>
                <h2>Alex Levin</h2>
                <h3>Executive Group President</h3>
                <p>49 COMPLETIONS</p>
                <p>18 BADGES</p>
                <p>4.5K HOURS</p>
              </div>
            </div>
            <div>
              <div className='liquidCystal2'>
                <Link to="/"><p><span>4</span>Courses Due Soon</p></Link>
                <hr></hr>
                <Link  to="/"><p><span>1</span>Overdue Courses</p></Link> 
                <hr></hr>
                <Link to="/"><p><span>3</span>Goals to Meet</p></Link>
              </div>
            </div>

          </div>
        </Col></>
}


function AvailableCourse(){
  const itemList = [
    {
      imageUrl: "../images/Bitmap.png",
      altText: "Liquid Crystal",
      title: "Because of your goal “X”",
      description: "Lorem Ipsum Playlist Title Here",
      progressTitle:"PROGRESS 57%",
      progress: 57,
      link:"RESUME"
    },
    {
      imageUrl: "../images/Group.png",
      altText: "Liquid Crystal",
      title: "Because of your goal “X”",
      description: "Lorem Ipsum Playlist Title Here",
      progressTitle:"PROGRESS 70%",
      progress: 70,
      link:"RESUME",
    },
    {
      imageUrl: "../images/Bitmap2.png",
      altText: "Liquid Crystal",
      title: "Because of your goal “X”",
      description: "Lorem Ipsum Playlist Title Here",
      link:"ADD TO LIBRARY",
      // progress: 0,

    }
  ]
return(
  <Col md={6} className="BackgroundBlack " id="LearningLibrary">
  <LearningLibrary className="LiquidCrystal-inner1">
    <h2 className="getStarted">Get Started</h2>
    <Link to="/" className="ViewLearning">VIEW MY LEARNING</Link>
  </LearningLibrary>
  <Swiper
      slidesPerView={3}
      spaceBetween={34}
      slidesPerGroup={3}
      loop={true}
      loopFillGroupWithBlank={true}
      pagination={{clickable: true,}}
      navigation={true}
      modules={[Pagination, Navigation]}
      
      breakpoints={{
        375: {
          slidesPerView: 1,
          slidesPerGroup:1
        },
        575: {
          slidesPerView:3,
          slidesPerGroup:3,
        }
      }} 
  >
   
     {itemList.map(({ imageUrl, altText, title, description, link, progress, progressTitle }, i) => (
        <SwiperSlide key={i}>
          <img src={imageUrl} alt={altText} className="CardImage" />
          <CardContent className="CardContent">
            <p>{title}</p>
            <h3>{description}</h3>
            <span>{progressTitle}</span>
            <CardProgress className="CardProgress">
                <ProgressBar now={progress} />
                <Link to="/">{link}</Link>
            </CardProgress>
          </CardContent>
        </SwiperSlide>  
    ))}
  </Swiper>
</Col>
)}

function LearnBetter (){
  const CarouselitemList = [
    {
      imageUrl: "../images/Rectangle80.png",
      altText: "Liquid Crystal",
      title: "Learn Better, Together",
    },
    {
      imageUrl: "../images/Rectangle80.png",
      altText: "Liquid Crystal",
      title: "Learn Better, Together ",
    },
    {
      imageUrl: "../images/Rectangle80.png",
      altText: "Liquid Crystal",
      title: "Learn Better, Together ",
    }
  ]

  return(
    <>  
    <Col md={6} id="SocialCommunities" >
    <Swiper
      cssMode={true}
      navigation={true}
      pagination={true}
      keyboard={true}
      modules={[Navigation, Pagination, Mousewheel, Keyboard]}
      className="mySwiper"
    >
      {CarouselitemList.map(({ imageUrl, altText, title, }, i) => (
        <SwiperSlide key={i}>
          <img src={imageUrl} alt={altText} className="learnBetter"/>
          <h3>{title}</h3>
          <SocialCommunities >
            Browse Social Communities
          </SocialCommunities>
        </SwiperSlide>
      ))}
    </Swiper>
  </Col></>
  )
}



function Home() {
  return (
    <Container fluid className="container-fluid LiquidCrystal">
      <Row >
        <SearchComponent />
        <Courses/>
      </Row>
      <Row>
        <AvailableCourse/>
        <LearnBetter/>
      </Row>
    </Container>
  
  )
}

export default Home